/**
 * U0002
 * 勤怠区分色情報
 */
export const u0002Variants: Record<string, string> = {
  "10": "white",
  "20": "waiting",
  "21": "waiting",
  "22": "waiting",
  "30": "completed",
  "40": "working",
  "50": "done",
  "51": "done",
  "70": "caution",
  "80": "caution",
  "90": "caution",
}
